import ArticleLink from "./ArticleLinks"
import {Box, Button, IconButton,} from "@mui/material"
import {useDispatch} from "react-redux"
import {clearState} from "../../../reducers/targetArticleSlice"
import {resetWorkingArticleNoteRelation} from "../../../reducers/workingArticleNoteRelationSlice"
import {Settings} from "@mui/icons-material"
import { useRef, useState} from "react"
import {ArticleSubmenu} from "./ArticleSubmenu.jsx"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function ArticleLinksAndControls({article, selected, fullText, setFullTextId, setArticleFiles, fromAutoSearch, articleWorkspace}) {
	return (
		<Box sx={{ fontSize: "small", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
			<div>
				{article.PMID && (
					<ArticleLink
						link={`https://pubmed.ncbi.nlm.nih.gov/${article.PMID}`}
						label={"PMID"}
						value={article.PMID}
						selected={selected}
					/>
				)}
				{article.DOI && (
					<ArticleLink
						link={`https://doi.org/${article.DOI}`}
						label={"DOI"}
						value={article.DOI}
						selected={selected}
					/>
				)}
				{article.ISBN && (
					<ArticleLink
						link={`https://isbnsearch.org/isbn/${article.ISBN}`}
						label={"ISBN"}
						value={article.ISBN}
						selected={selected}
					/>
				)}
				{article.ARXIVID && (
					<ArticleLink
						link={`https://arxiv.org/abs/${article.ARXIVID}`}
						label={"arXiv"}
						value={article.ARXIVID}
						selected={selected}
					/>
				)}
			</div>
			{ selected && (
				<CloseArticleMenu
					fullText={fullText}
					setFullTextId={setFullTextId}
					setArticleFiles={setArticleFiles}
					fromAutoSearch={fromAutoSearch}
					articleWorkspace={articleWorkspace}
				/>
			)}
		</Box>
	)
}

function CloseArticleMenu({fullText, setFullTextId, setArticleFiles, fromAutoSearch, articleWorkspace}) {
	const dispatch = useDispatch()
	const anchorElRef = useRef(null)
	const [openSubMenu, setOpenSubMenu] = useState(false)
	const {workspaceId} = useWorkspaceContext()

	return (
		<Box sx={{
			flex: "0 1 33%",
			textTransform: "none",
			marginRight: "10px",
			minHeight: "26px",
			transition: "background-color color 250ms ease-in",
			zIndex: 200,
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
			borderRadius: "4px",
			alignItems: "center",
		}}>
			<Button
				sx={{
					textTransform: "none",
					margin: "0",
					padding: "0",
					color: "alertRed.main",
					transition: "background-color color 250ms ease-in",
					flex: "1 0 auto",
					fontSize: "0.875rem",
					fontWeight: "700",
					boxSizing: "border-box",
					"&:hover": {
						backgroundColor: "primary.transparency20",
						color: "alertRed.mainTransparency100",
					}
				}}
				size={"small"}
				variant="text"
				onClick={() => {
					dispatch(clearState(workspaceId))
					dispatch(resetWorkingArticleNoteRelation(workspaceId))
				}}
			>
				Close Citation
			</Button>
			<IconButton
				onClick={() => {setOpenSubMenu(true)}}
				ref={anchorElRef}
				sx={{
					minWidth: "30px",
					borderRadius: "4px",
					flex: "0 0 auto",
					"&:hover": {
						backgroundColor: "primary.transparency20",
						color: "alertRed.mainTransparency100",
					}
				}}
			>
				<Settings fontSize={"small"}/>
			</IconButton>
			<ArticleSubmenu
				fullText={fullText}
				setFullTextId={setFullTextId}
				setArticleFiles={setArticleFiles}
				fromAutoSearch={fromAutoSearch}
				articleWorkspace={articleWorkspace}
				anchorElRef={anchorElRef}
				openSubMenu={openSubMenu}
				setOpenSubMenu={setOpenSubMenu}
			/>
		</Box>
	)
}